export const events = {
  shareTaskOpened: 'Share Task modal is opened',
  shareTaskSaved: 'Add new sharees for the task',
  taskCommentReactionAdded: 'Task Comment Reaction Added',
  taskCommentReactionRemoved: 'Task Comment Reaction Removed',
}
